import { useRef, useEffect } from 'react';

import useMount from '@picsart/rc/useMount';

import { toggleHtmlClassName } from 'utils/themes/utils';

import { changeThemeColors } from './colors';

const useChangeColors = (isDark = false) => {
  const styleRef = useRef<HTMLStyleElement | null>(null);

  useEffect(() => {
    toggleHtmlClassName(isDark);
    styleRef.current?.remove();
    styleRef.current = changeThemeColors();
    document.head.appendChild(styleRef.current);
  }, [isDark]);

  useMount(() => () => styleRef.current?.remove());
};

export default useChangeColors;
